import B1 from '../styles/images/wounds/B1.png';
import B10 from '../styles/images/wounds/B10.png';
import B11 from '../styles/images/wounds/B11.png';
import B12 from '../styles/images/wounds/B12.png';
import B13 from '../styles/images/wounds/B13.png';
import B14 from '../styles/images/wounds/B14.png';
import B15 from '../styles/images/wounds/B15.png';
import B16 from '../styles/images/wounds/B16.png';
import B17 from '../styles/images/wounds/B17.png';
import B18 from '../styles/images/wounds/B18.png';
import B19 from '../styles/images/wounds/B19.png';
import B2 from '../styles/images/wounds/B2.png';
import B20 from '../styles/images/wounds/B20.png';
import B21 from '../styles/images/wounds/B21.png';
import B22 from '../styles/images/wounds/B22.png';
import B23 from '../styles/images/wounds/B23.png';
import B3 from '../styles/images/wounds/B3.png';
import B4 from '../styles/images/wounds/B4.png';
import B5 from '../styles/images/wounds/B5.png';
import B6 from '../styles/images/wounds/B6.png';
import B7 from '../styles/images/wounds/B7.png';
import B8 from '../styles/images/wounds/B8.png';
import B9 from '../styles/images/wounds/B9.png';
import BACK from '../styles/images/wounds/BACK.png';
import F1 from '../styles/images/wounds/F1.png';
import F10 from '../styles/images/wounds/F10.png';
import F11 from '../styles/images/wounds/F11.png';
import F12 from '../styles/images/wounds/F12.png';
import F13 from '../styles/images/wounds/F13.png';
import F14 from '../styles/images/wounds/F14.png';
import F15 from '../styles/images/wounds/F15.png';
import F16 from '../styles/images/wounds/F16.png';
import F17 from '../styles/images/wounds/F17.png';
import F18 from '../styles/images/wounds/F18.png';
import F19 from '../styles/images/wounds/F19.png';
import F2 from '../styles/images/wounds/F2.png';
import F20 from '../styles/images/wounds/F20.png';
import F21 from '../styles/images/wounds/F21.png';
import F22 from '../styles/images/wounds/F22.png';
import F23 from '../styles/images/wounds/F23.png';
import F3 from '../styles/images/wounds/F3.png';
import F4 from '../styles/images/wounds/F4.png';
import F5 from '../styles/images/wounds/F5.png';
import F6 from '../styles/images/wounds/F6.png';
import F7 from '../styles/images/wounds/F7.png';
import F8 from '../styles/images/wounds/F8.png';
import F9 from '../styles/images/wounds/F9.png';
import FRONT from '../styles/images/wounds/FRONT.png';
import FT_L_I from '../styles/images/wounds/FT_L_I.png';
import FT_L_P1 from '../styles/images/wounds/FT_L_P1.png';
import FT_L_P2 from '../styles/images/wounds/FT_L_P2.png';
import FT_L_P3 from '../styles/images/wounds/FT_L_P3.png';
import FT_R_I from '../styles/images/wounds/FT_R_I.png';
import FT_R_P1 from '../styles/images/wounds/FT_R_P1.png';
import FT_R_P2 from '../styles/images/wounds/FT_R_P2.png';
import FT_R_P3 from '../styles/images/wounds/FT_R_P3.png';
import F22_1 from '../styles/images/wounds/F22_1.png';
import F22_2 from '../styles/images/wounds/F22_2.png';
import F22_3 from '../styles/images/wounds/F22_3.png';
import F23_1 from '../styles/images/wounds/F23_1.png';
import F23_2 from '../styles/images/wounds/F23_2.png';
import F23_3 from '../styles/images/wounds/F23_3.png';

export default {
  B1,
  B10,
  B11,
  B12,
  B13,
  B14,
  B15,
  B16,
  B17,
  B18,
  B19,
  B2,
  B20,
  B21,
  B22,
  B23,
  B3,
  B4,
  B5,
  B6,
  B7,
  B8,
  B9,
  BACK,
  F1,
  F10,
  F11,
  F12,
  F13,
  F14,
  F15,
  F16,
  F17,
  F18,
  F19,
  F2,
  F20,
  F21,
  F22,
  F23,
  F3,
  F4,
  F5,
  F6,
  F7,
  F8,
  F9,
  FRONT,
  FT_L_I,
  FT_L_P1,
  FT_L_P2,
  FT_L_P3,
  FT_R_I,
  FT_R_P1,
  FT_R_P2,
  FT_R_P3,
  F22_1,
  F22_2,
  F22_3,
  F23_1,
  F23_2,
  F23_3,
};



// WEBPACK FOOTER //
// ./src/constants/WoundLocationImages.js